import _ from 'lodash';

import entidadeTemplate from './contexto/entidade/selecao/selecao-entidade.html';
import sistemaTemplate from './contexto/sistema/selecao/selecao-sistema.html';
import subcontextoTemplate from './contexto/subcontexto/selecao/selecao-subcontexto.html';

export default function States(stateProvider, $urlRouterProvider, constants) {
  $urlRouterProvider.otherwise('/entidades');

  const states = {
    main: {
      route: {
        abstract: true,
        views: {
          content: {},
        },
      },
    },
    entidade: {
      parent: 'main',
      route: {
        url: '/entidades',
        views: {
          '@content': {
            template: entidadeTemplate,
            controller: 'SelecaoEntidadeController as vm'
          },
        },
      },
      context: {
        value: 'entidade',
        manager: 'EntidadeContextoManagerService',
      },
    },
    sistema: {
      parent: 'entidade',
      route: {
        url: '/sistemas',
        views: {
          '@content': {
            template: sistemaTemplate,
            controller: 'SelecaoSistemaController as vm',
          },
        },
      },
      context: {
        value: 'APP_SYSTEM',
        manager: 'SistemaContextoManagerService',
      },
    },
    subcontexto: {
      parent: 'sistema',
      route: {
        url: '/subcontextos',
        views: {
          '@content': {
            template: subcontextoTemplate,
            controller: 'SelecaoSubcontextoController as vm',
          },
        },
      },
      context: {
        value: 'SUBCONTEXTO_HASH',
        manager: 'SubcontextoContextoManagerService',
      },
    },
    visaoGeralSistema: {
      parent: 'sistema',
      route: {
        url: '',
        views: {
          '@content': {
            templateUrl: constants.services.autorizacoesUi.concat(
              '/access/dashboard.html'
            )
          }
        },
        resolve: {
          activateUserAccess: [
            'APP_SYSTEM',
            'SistemaContextoManagerService',
            (sistema, sistemaContextoManager) =>
              sistemaContextoManager.activateUserAccess(sistema),
          ],
        },
        standalone: true
      }
    },
    visaoGeralSubcontexto: {
      parent: 'subcontexto',
      route: {
        url: '',
        views: {
          '@content': {
            templateUrl: constants.services.autorizacoesUi.concat(
              '/access/dashboard.html'
            )
          }
        },
        standalone: true
      }
    }
  };

  _.forEach(states, (state, nome) => {
    const start = state.parent ? stateProvider.from(state.parent) : stateProvider;
    start.create(nome, state.route, state.context);
  });
}

States.$inject = [
  'bfcStateProvider',
  '$urlRouterProvider',
  'CONSTANTS'
];
